<template>
  <Modal>
    <Modal.Title>Change email</Modal.Title>
    <Modal.Body>
      <div class="flex flex-col gap-4">
        <Input
          v-model="newEmail"
          size="xl"
          type="email"
          label="New email"
          :disabled="loading"
        />
        <Input
          v-model="confirmEmail"
          size="xl"
          type="email"
          label="Confirm email"
          :disabled="loading"
        />
        <Alert v-if="error" variant="error" :icon="AlertIcon">
          {{ error }}
        </Alert>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" :disabled="loading" @click="close()">
        Cancel
      </Button>
      <Button
        variant="primary"
        :disabled="!canSave"
        :loading="loading"
        @click="handleSave"
      >
        Save
      </Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { Modal, Input, Button, Alert, useModal } from '@dacr/library'
import { AlertIcon } from '@dacr/icons'
import type { User } from '@/shared/graphql/legacy/generated'
import { useChangeEmail } from './useChangeEmail'

const { close } = useModal()

defineProps<{
  user: User
}>()

const { newEmail, confirmEmail, error, loading, canSave, save } =
  useChangeEmail()

const handleSave = async () => {
  if (await save()) close()
}
</script>
